import React from 'react'
import styled from 'styled-components';
import { DashboardContent } from '@/containers/DashboardLayout/DashboardContent'
import { DashboardHeader } from '@/containers/DashboardLayout/DashboardHeader'
import { DashboardLayout } from '@/containers/DashboardLayout'

const ChatContent = styled.div`
    display: flex;
    width: 100%;
    background: white;
    flex-grow: 1;
`

export const ContractsLayout = ({ children }) => {
    return (
        <DashboardLayout>
            <DashboardHeader>
                <span className="header-title">Contracten</span>
            </DashboardHeader>
            <DashboardContent>
                <ChatContent>
                    {children}
                </ChatContent>
            </DashboardContent>
        </DashboardLayout>
    )
}
